import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-239d1b7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-main-full-height" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-map-marker fas" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "__camera"
}
const _hoisted_4 = { class: "__canvas" }
const _hoisted_5 = { ref: "canvas" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-camera fas" }, null, -1))
const _hoisted_7 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, null, {
      header: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("text.uploadImage")), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-position": "top",
          ref: "form",
          model: _ctx.form
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('label.monitorizationPoint'),
              prop: "samplingpoints",
              class: "d-flex flex-column"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.samplingPoint,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.samplingPoint) = $event)),
                  filterable: "",
                  "value-key": "id"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.samplingpoints, (samPoint) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: samPoint.id,
                        label: samPoint.name,
                        value: samPoint
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_button, {
                  class: "ms-1",
                  onClick: _ctx.checkUserLocation,
                  type: 
              _ctx.samplingPoint && !_ctx.disableCamera ? 'success' : !_ctx.samplingPoint ? 'primary' : 'danger'
            
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["onClick", "type"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model"]),
        (_ctx.capture.scanRuning)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("canvas", _hoisted_5, null, 512)
              ]),
              _createVNode(_component_el_button, {
                type: _ctx.disableCamera ? 'primary' : _ctx.capture.qrIsValid ? 'success' : 'danger',
                disabled: !_ctx.samplingPoint || _ctx.disableCamera || !_ctx.capture.scanRuning || !_ctx.capture.qrIsValid,
                class: "w-100 __camera-take",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.captureTake()))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["type", "disabled"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_dialog, {
          fullscreen: true,
          modelValue: _ctx.visibleDialog,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visibleDialog) = $event)),
          title: _ctx.$t('title.sendManualCapture')
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_button, {
                onClick: _cache[2] || (_cache[2] = () => (_ctx.image = ''))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleSubmit()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("btn.send")), 1)
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            (_ctx.image)
              ? (_openBlock(), _createBlock(_component_el_image, {
                  key: 0,
                  src: _ctx.image,
                  "preview-src-list": [_ctx.image],
                  ref: "dialogImage"
                }, null, 8, ["src", "preview-src-list"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "title"])
      ]),
      _: 1
    })
  ]))
}